import axios from "axios";
import { getToken } from "./utilsApi";

/**
 * Client for the dashboard AI assistant (/portal/assistant on the portal API, phase 2 back end).
 *   - askAssistant:  POST a question (+ recent turns) and get { answer, links, used, limit }
 *   - assistantUsage: GET this month's { used, limit } for the caller's district
 * District/school scope is enforced on the server from the signed-in user; `district` is only
 * used for DiscloSure admins (who pick one in the dashboard filter).
 */
const assistantUrl = () => `${process.env.REACT_APP_apiBaseUrl}assistant`;

const errorMessage = (error) =>
  error?.response?.data?.message || "The assistant couldn't answer right now. Please try again.";

export const askAssistant = async ({ question, history, district }) => {
  const token = await getToken();
  try {
    const res = await axios({
      method: "POST",
      url: assistantUrl(),
      headers: { "x-api-key": token, "Content-Type": "application/json" },
      data: { question, history, ...(district ? { district } : {}) },
      timeout: 35000,
    });
    return { ok: true, ...res.data };
  } catch (error) {
    return { ok: false, status: error?.response?.status, message: errorMessage(error) };
  }
};

export const assistantUsage = async (district) => {
  const token = await getToken();
  try {
    const res = await axios({
      method: "GET",
      url: assistantUrl(),
      headers: { "x-api-key": token },
      params: district ? { district } : {},
    });
    return { ok: true, ...res.data };
  } catch (error) {
    return { ok: false };
  }
};
